import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { RouteComponent, RouteRecordNameGeneric, RouteRecordRaw } from 'vue-router';

export type LocalizeRouteRaw = Omit<RouteRecordRaw, 'redirect'>;

export interface LocalizedRoutes {
  de: LocalizeRouteRaw;
  en: LocalizeRouteRaw;
  fr: LocalizeRouteRaw;
  it: LocalizeRouteRaw;
}

const SEPARATOR = '-';

export const getRouteNameWithLanguage = (prefix: string, locale: HgSupportedLanguage) =>
  `${prefix}${SEPARATOR}${locale}`;

export const getRouteName = (name: RouteRecordNameGeneric) =>
  (name ?? '').toString().split(SEPARATOR)[0];

export const generateLocalizedRouteConfig = (
  localizedRoutes: LocalizedRoutes,
  component: RouteComponent,
  prefix: string,
): RouteRecordRaw[] =>
  Object.entries(localizedRoutes).map(([locale, { path, meta }]) => ({
    path,
    component,
    name: getRouteNameWithLanguage(prefix, locale as HgSupportedLanguage),
    meta: {
      locale,
      getLanguageSwitchLink(route: any, language: HgSupportedLanguage) {
        return {
          name: getRouteNameWithLanguage(prefix, language),
          query: route.query,
          params: route.params,
        };
      },
      ...meta,
    },
  }));
